import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../_constants/constants';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Check if we're in browser environment
        const isBrowser = typeof window !== 'undefined' && typeof localStorage !== 'undefined';

        // add the language header and client app
        const language = isBrowser ? localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY) ?? '' : '';
        request = request.clone({
            headers: request.headers
                .append('Accept-Language', language)
                .append('Client-App', AppConstants.CLIENT_APP)
        });

        // add authorization header with jwt token if available
        const tokenDetailsJson = isBrowser ? localStorage.getItem('tokenDetails') : null;
        const tokenDetails = tokenDetailsJson ? JSON.parse(tokenDetailsJson) : null;

        if ((request.url.includes('shipping_offers') || request.url.includes('/shippingOptions')
            || request.url.includes('/shippingPricing')
            || request.url.includes('/cities')
            || request.url.includes('/oauth/logout')
            || request.url.includes('/user') || request.url.includes('secure') || request.url.includes('/payments') || request.url.includes('/documents')
            || request.url.includes('/packages') || request.url.includes('/subscriptions')
            || request.url.includes('/lineOffers')
            || request.url.includes('/deliveryRequests')
            || request.url.includes('/common/get_cart_identifier')
            || (request.url.includes("offers") && request.url.includes("reviews"))
            || request.url.includes('/sales')
            || request.url.includes('/taxonomies'))
            && tokenDetails != null && tokenDetails.access_token) {
            return next.handle(request.clone({
                headers: request.headers.append('Authorization', 'Bearer ' + tokenDetails.access_token)
            }));
        } else if (request.url.includes('/oauth/token') || request.url.includes('/oauth/verify_token/')) {
            return next.handle(request.clone({
                headers: request.headers.append('Authorization', 'Basic ZWZhcm0td2ViLWFwcDplZmFybS13ZWItYXBw')
            }));
        } else {
            return next.handle(request);
        }
    }
}
